<template>
  <div>
    <el-row  :gutter="20">
      <router-link to="/check"><el-col :span="12" ><div class="grid-content">PDA验收</div></el-col></router-link>

      <!--<router-link to="/search"><el-col :span="12"><div class="grid-content">电脑验收</div></el-col></router-link>-->

      <router-link to="/multi"><el-col :span="12"><div class="grid-content">多品发货</div></el-col></router-link>

    </el-row>
  </div>
</template>

<script>
export default {
  name: "Menu",
}
</script>

<style scoped lang="stylus">

.grid-content
  height 5rem
  background-color #cfd5e5
  border-radius 1rem
  line-height 5rem
  text-align center
  color #393d49
  margin-top 20px

</style>
